import React, { Component } from 'react';
import Parse from 'parse'
import { withRouter } from 'react-router';
import Helmet from 'react-helmet';
import styled from 'styled-components'
import { withCookies, Cookies } from 'react-cookie';
import { inject, observer, Observer, PropTypes as MobxPropTypes } from 'mobx-react';

import MultistepForm from '../components/onboarding/MultistepForm';
import OnboardingLayout from '../components/onboarding/OnboardingLayout';
import GolfCourseMap from '../components/marketing/GolfCourseMap';
import cssVar from '../styles/variables'

import config from 'react-global-configuration';

import { SocialWrapper, RequiredNoticeText, Link, Heading2, Heading4, FullWidthWrapper, FullAreaWrapper, Centered, TextField, SelectWrapper, Select, PrimaryButton, SecondaryButton, NoticeText, ErrorText, SectionHeading, SectionText, Text, GridRow } from '../components/marketing/MarketingStyles';
import checkmark from '../images/icons/checkmark.svg'
import failuremark from '../images/icons/failuremark.svg'

import { Facebook, LinkedIn } from '../images/icons/Icons';

import { trackEvent } from "../utils/eventTracking"

@inject('partnerInformationStore', 'utilStore')
@observer
class Application extends Component {

  constructor(props) {
    super(props)
    this.state = {}

    this.props.partnerInformationStore.loadIndustries()
  }

  componentDidMount() {
    const { checkAvailibility } = this.props.utilStore
    if(this.form && checkAvailibility) {
      this.props.utilStore.setCheckAvailibility(undefined);
      this.form.updateProperty("region", checkAvailibility.region_slug)
      this.checkAvailibility()
    }
  }

  checkAvailibility = async () => {
    const { available } = await Parse.Cloud.run("checkRegionAvailibitlity", { region_slug: this.form.state.properties.region }).catch(err => console.error(err))

    trackEvent( 'Apply - Verfügbarkeit Prüfen', 'Application Process', 'Form Submission' )

    this.form.state.properties.waitlist = !available

    this.saveProgress(this.form.state.properties)

    if( !available ) {
      this.form.selectSub(2)
    } else {
      this.props.cookies.remove('application-prefill',{ path:'/' })
      this.form.selectSub(1)
    }

    // if( !this.props.cookies.get('application-prefill') )
      // return this.form.selectSub(0)

    
  }

  getApplicationToken = () => {
    let token = this.props.cookies.get('applicationToken')
    if(!token) {
      token = (Math.random() + 1).toString(36).substring(3).toUpperCase()
      this.props.cookies.set('applicationToken', token, { maxAge: 60 * 60 * 24 * 365 });
    }
    return token
  }

  saveProgress = ( properties ) => {
    const { regions } = this.props.utilStore
    // console.log(properties && regions.find(item => properties.region == item.slug));
    // console.log(properties && regions.find(item => properties.region == item.slug).id);
    // const data = { ...properties, region: properties && regions.find(item => properties.region == item.slug).object}
    Parse.Cloud.run("updateApplicationProgress", { progressId: this.getApplicationToken(), ...properties}).then(() => console.info("saved progress")).catch(err => console.error(err))
  }

  onLoadForm = () => {
    if(this.form && this.props.cookies.get('applicationToken')) {
      ( new Parse.Query("ApplicationProgress") ).equalTo( "progressId", this.getApplicationToken() ).notEqualTo("isCompleted", true).first().then(res => {
        let properties = res.toJSON()

        const { email: mail, address: company_address, city: company_city, postcode: company_postcode, knownMember: known_member, golfcourse: golf_course, region, ...rest } = properties

        console.log("SLUG", region);
        console.log("SLUG", region.slug);

        properties = {
          mail,
          company_address,
          company_city,
          company_postcode,
          known_member,
          golf_course,
          country: '',
          region: region && region.slug,
          country: region && region.country.slug,
          ...rest
        }

        this.form.updateProperties(properties, true)
      })

    } else if(this.props.cookies.get('application-prefill')) {
      const data = this.props.cookies.get('application-prefill')

      const properties = {
        mail: data.mail,
        region: data.region,
        phone: data.phone,
        firstname: data.firstname,
        lastname: data.lastname,
        company: data.company,
      }

      setTimeout(() => {
        this.form.updateProperties(properties, true)
        this.checkAvailibility()
      }, 100)
      // this.form.updateProperty("region", data.region)
      // if(properties.region) this.checkAvailibility()

    }
  }

  render() {

    const { loaded, regions, countries } = this.props.utilStore
    const { social_links, application } = this.props.utilStore.util

    const DefaultSideContent = () => (<img src={`${config.get('CLOUDINARY_URL')}${ application.sideImage }.jpg`} style={{ height: '100%', width: '100%', objectFit: 'cover', maxHeight: '100vh', maxWidth: '50vw' }} />)
    const CheckLocationSideContent = () => (<GolfCourseMap />)

    const SocialSection = () => (
      <SocialWrapper>
        <Link href={ social_links && social_links.facebook } target="_blank"><Facebook /></Link>
        <Link href={ social_links && social_links.linkedin } target="_blank"><LinkedIn /></Link>
      </SocialWrapper>
    )

    const DataPolicyNotice = () => (
      <NoticeText>Mit dem Klicken des Button bestätigen Sie unsere <DataPolicyLink onClick={ () => this.props.history.push("/datenschutz")}>Datenschutzbestimmung</DataPolicyLink> und somit die Verarbeitung Ihrer Daten.</NoticeText>
    )

    const CheckLocation = ({ next, Progressbar, selectSub, updateProperty, TrackedSelectField, properties }) => {

      if(!properties.country) updateProperty('country', 'austria')
      if(!properties.region) updateProperty('region', 'wien')

      const currentRegions = regions && regions.filter(item => item.country.get('slug') == properties.country )
      const selectedCountry = properties.country
      const regionObject = currentRegions.find(item => item.slug == properties.region)
      const selectedRegion = ( properties.region && regionObject && regionObject.country.get('slug') == selectedCountry) ? properties.region : currentRegions[0].slug

      if(properties.region != selectedRegion) updateProperty('region', selectedRegion)

      const Content = () => (
        <FullWidthWrapper>
          <Heading2>Verfügbarkeit prüfen</Heading2>
          <Text>Um unser Netzwerk stets qualitativ und attraktiv für Mitglieder zu gestalten, prüfen wir vor einer Bewerbung, ob noch ausreichend Platz in der gewünschten Region verfügbar ist.</Text>

          <GridRow
            desktop="1fr 2fr"
            phone="1fr" phoneRowGap
            style={{margin: '30px 0 0 0'}}
          >
            <SelectWrapper>
              <Select onChange={e => updateProperty('country', e.target.value, true) }>
                { countries && countries.map((item, index) => <option key={item.slug} value={item.slug} selected={item.slug == selectedCountry}>{item.title}</option>) }
              </Select>
            </SelectWrapper>
            <SelectWrapper>
              <Select onChange={e => updateProperty('region', e.target.value) }>
                { currentRegions && currentRegions.map((item, index) => <option key={item.slug} value={item.slug} selected={item.slug == selectedRegion}>{item.title}</option>) }
              </Select>
            </SelectWrapper>
          </GridRow>
          <FullAreaWrapper style={{ display: 'flex' }}>
            <PrimaryButton
              value="Verfügbarkeit prüfen"
              onClick={ this.checkAvailibility }
            />
          </FullAreaWrapper>

        </FullWidthWrapper>
      )

      return (
        <OnboardingLayout content={ Content } sideContent={ CheckLocationSideContent } topContent={ Progressbar }/>
      )
    }

    const CheckLocationSlotsAvailable = ({ next, Progressbar }) => {

      const Content = () => (
          <FullWidthWrapper style={{ textAlign: 'center' }}>
            <img src={ checkmark } style={{marginBottom: 50}} />
            <Heading2>Gratulation! <br /> Es sind freie Plätze verfügbar!</Heading2>

            <PrimaryButton
              value="jetzt bewerbung prüfen"
              onClick={ next }
            />
          </FullWidthWrapper>
      )

      return (
        <OnboardingLayout content={ Content } sideContent={ CheckLocationSideContent } topContent={ Progressbar } />
      )
    }

    const CheckLocationNoSlotsAvailable = ({ next, Progressbar }) => {

      // const validateAndNext = () => {

      //   Parse.Cloud.run("joinApplicationWaitlist", { name: properties.name, mail: properties.mail, phone: properties.phone, postcode: properties.postcode, region_slug: properties.region })
      //     .then(res => selectSub(3))
      //     .catch(err => console.error(err))

      // }

      const Content = () => (
        <FullWidthWrapper style={{ textAlign: 'center' }}>
          <img src={ failuremark } style={{marginBottom: 50}} />
          <Heading2>Zur Zeit sind in Ihrer Region leider keine Plätze mehr verfügbar.</Heading2>
          <Text>Sie können schon jetzt Ihre Bewerbung prüfen und absenden. <br />Wir melden uns dann bei Ihnen sobald in Ihrer Region wieder Plätze verfügbar sind.</Text>

          <PrimaryButton
              value="jetzt bewerbung prüfen"
              onClick={ next }
            />
        </FullWidthWrapper>
      )

      return (
        <OnboardingLayout content={ Content } sideContent={ CheckLocationSideContent } topContent={ Progressbar } />
      )
    }

    // const CheckLocationJoinedWaitlist = ({ Progressbar }) => {

    //   const Content = () => (
    //     <FullWidthWrapper style={{ textAlign: 'center' }}>
    //       <img src={ checkmark } style={{marginBottom: 50}} />
    //       <Heading2>Vielen Dank für Ihr Vertrauen. Sobald Plätze frei werden kontaktieren wir Sie.</Heading2>

    //       <GridRow
    //         style={{margin: '30px 0'}}
    //         desktop="1fr 1fr"
    //         phone="1fr"
    //         phoneRowGap
    //       >
    //         <PrimaryButton
    //           value="Home"
    //           onClick={ e => { e.preventDefault(); this.props.history.push("/")} }
    //         />
    //         <SecondaryButton
    //           value="Kontakt"
    //           onClick={ e => { e.preventDefault(); this.props.history.push("/kontakt")} }
    //         />
    //       </GridRow>
    //       <SocialSection />
    //     </FullWidthWrapper>
    //   )

    //   return (
    //     <OnboardingLayout content={ Content } sideContent={ CheckLocationSideContent } topContent={ Progressbar } />
    //   )
    // }

    const PersonalInformation = ({ next, Progressbar, TrackedTextField, TrackedDatePicker, properties, updateProperty }) => {

      const validateAndNext = () => {
        this.saveProgress( properties )
        trackEvent( 'Apply - Submit Contact Data', 'Application Process', 'Form Submission' )
        next()
      }

      const Content = () => (
        <FullWidthWrapper>
          <Heading4>Wie dürfen wir Sie begrüßen?</Heading4>
          <Heading2>Ihre Kontaktdaten</Heading2>

          <form onSubmit={e => { e.preventDefault(); validateAndNext()} }>

            <GridRow
              desktop="1fr 2fr 2fr"
              phone="1fr"
            >
              <TrackedTextField slug="title" placeholder="Titel" />
              <TrackedTextField slug="firstname" placeholder="Vorname *" required
                pattern="[a-zA-z\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df]{3}[a-zA-z\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df ]*"
                title="Mindestens 3 Buchstaben, keine Sonderzeichen"
              />
              <TrackedTextField slug="lastname" placeholder="Nachname *" required
                pattern="[a-zA-z\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df]{3}[a-zA-z\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df ]*"
                title="Mindestens 3 Buchstaben, keine Sonderzeichen"
              />
            </GridRow>

            <TrackedDatePicker slug="birthdate" placeholder="Geburtsdatum *"/>

            {/* <GridRow desktop="6fr 2fr">
              <TrackedTextField slug="city" placeholder="* Wohnort" required/>
              <TrackedTextField slug="postcode" placeholder="* PLZ" type="number" required/>
            </GridRow>

            <GridRow desktop="1fr">
              <TrackedTextField slug="address" placeholder="* Anschrift" required/>
            </GridRow> */}

            <GridRow desktop="1fr">
              <TrackedTextField slug="mail" placeholder="Mail-Adresse *" type="email" required/>
            </GridRow>

            <GridRow desktop="1fr">
              <TrackedTextField slug="phone" placeholder="Telefonnummer *" type="tel" required
                pattern="\+\d{5}\d*"
                title="Telefonnummer z.B.: +436641234567"
              />
            </GridRow>

            <GridRow desktop="1fr">
              <TrackedTextField slug="known_member" placeholder="Welches Mitglied kennen Sie?" />
            </GridRow>

            <RequiredNoticeText>Felder mit  * gekennzeichnet sind Pflichtfelder</RequiredNoticeText>

            <PrimaryButton
              style={{marginTop: 30}}
              value="weiter zu den Business Daten"
            />

            <DataPolicyNotice />

          </form>

        </FullWidthWrapper>
      )

      return (
        <OnboardingLayout content={ Content } sideContent={ DefaultSideContent } topContent={ Progressbar } />
      )
    }

    const CompanyInformation = ({ next, Progressbar, TrackedSelectField, TrackedTextField, properties, updateProperty }) => {

      const validateAndNext = () => {
        this.saveProgress( properties )
        trackEvent( 'Apply - Submit Business Data', 'Application Process', 'Form Submission' )
        next()
      }

      const industryData = this.props.partnerInformationStore.industries

      const selectIndustry = value => {
        const industyObj = industryData.find(entry => entry.slug === value)
        updateProperty('industry_name', industyObj ? industyObj.name : value)
      }

      const Content = () => (
        <FullWidthWrapper>
          <Heading4>Sehr geehrte/r Herr/Frau {properties.lastname}</Heading4>
          <Heading2>Bitte ergänzen Sie noch Ihre Firmendaten</Heading2>

          <form onSubmit={e => { e.preventDefault(); validateAndNext()} }>

            <GridRow desktop="1fr">
              <TrackedTextField slug="company" placeholder="Unternehmen *" required />
            </GridRow>

            <GridRow
              desktop="1fr 1fr"
              phone="1fr"
            >
              <TrackedTextField slug="uid" placeholder="UID *" required />

              { industryData != null &&
                <TrackedSelectField slug="industry" onChange={ selectIndustry } required>
                  <option value="" disabled selected hidden>Branche *</option>
                  {
                    industryData.map((industry, key) => (
                      <option value={ industry.slug } key={ industry.slug }>{ industry.name }</option>
                    ))
                  }
                </TrackedSelectField>
              }

            </GridRow>

            <GridRow
              desktop="6fr 2fr"
              phone="1fr"
             >
              <TrackedTextField slug="company_city" placeholder="Firmensitz *" required/>
              <TrackedTextField slug="company_postcode" placeholder="PLZ *" type="number" required/>
            </GridRow>

            <GridRow desktop="1fr">
              <TrackedTextField slug="company_address" placeholder="Firmenanschrift *" required/>
            </GridRow>

            <GridRow desktop="1fr">
              <TrackedTextField slug="position" placeholder="Position *" required />
            </GridRow>
            <RequiredNoticeText>Felder mit * gekennzeichnet sind Pflichtfelder</RequiredNoticeText>

            <PrimaryButton
              style={{marginTop: 30}}
              value="weiter zu Ihren Golfdaten"
            />

            <DataPolicyNotice />

          </form>

        </FullWidthWrapper>
      )

      return (
        <OnboardingLayout content={ Content } sideContent={ DefaultSideContent } topContent={ Progressbar } />
      )
    }

    const GolfInformation = ({ next, Progressbar, TrackedTextField, properties }) => {

      const validateAndNext = () => {
        this.saveProgress( properties )
        trackEvent( 'Apply - Submit Golf Data', 'Application Process', 'Form Submission' )
        next()
      }

      const Content = () => (
        <FullWidthWrapper>
          <Heading4>Vielen Dank für Ihre bisherige Geduld</Heading4>
          <Heading2>Teilen Sie uns noch bitte Ihre Golf Daten mit</Heading2>

          <form onSubmit={e => { e.preventDefault(); validateAndNext()} }>

            <GridRow
              desktop="6fr 2fr"
              phone="1fr"
            >
              <TrackedTextField slug="golf_course" placeholder="Heimat Golfclub" />
              <TrackedTextField slug="handicap" placeholder="Handicap" type="number" />
            </GridRow>

            {/* <RequiredNoticeText>Felder mit * gekennzeichnet sind Pflichtfelder</RequiredNoticeText> */}

            <PrimaryButton
              style={{marginTop: 30}}
              value="nächster schritt"
            />

            <DataPolicyNotice />

          </form>

        </FullWidthWrapper>
      )

      return (
        <OnboardingLayout content={ Content } sideContent={ DefaultSideContent } topContent={ Progressbar } />
      )
    }

    const ReviewData = ({ next, Progressbar, TrackedTextField, properties, select, selectSub }) => {

      const apply = () => {
        trackEvent( 'Apply - Submit All Data', 'Application Process', 'Form Submission' )
        Parse.Cloud.run("createApplicationFromProgress", { progressId: this.getApplicationToken() })
          .then(res => selectSub(1))
          .then(() => this.props.cookies.remove('applicationToken'))
          .catch(err => console.error(err))
      }

      const Content = () => (
        <FullWidthWrapper>
          <Heading4>Prüfen Sie ein letztes Mal</Heading4>
          <Heading2>Ihre Daten</Heading2>

          <EditInsetGrid>
            <EditColumn>
              <EditButton onClick={ () => select(0) }>bearbeiten</EditButton>
            </EditColumn>
            <div>
              <SectionHeading>Persönliche Daten</SectionHeading>
              <SectionText>{ properties.title } { properties.firstname } { properties.lastname }</SectionText>
              <SectionText>{ properties.birthdate } </SectionText>
              <SectionText>{ properties.phone } </SectionText>
              <SectionText>{ properties.mail } </SectionText>
              {/* <SectionText>{ properties.plz } { properties.city } </SectionText>
              <SectionText>{ properties.address } </SectionText> */}
              <SectionText>{ properties.known_member ? 'kennt: ' + properties.known_member : '' } </SectionText>
            </div>
          </EditInsetGrid>


          <EditInsetGrid>
            <EditColumn>
              <EditButton onClick={ () => select(1) }>bearbeiten</EditButton>
            </EditColumn>
            <div>
              <SectionHeading>Firmendaten</SectionHeading>
              <SectionText>{ properties.company }</SectionText>
              <SectionText>Position: { properties.position } </SectionText>
              <SectionText>{ properties.company_plz } { properties.company_city } </SectionText>
              <SectionText>{ properties.company_address } </SectionText>
              <SectionText>UID: { properties.uid } </SectionText>
              <SectionText>Branche: { properties.industry_name } </SectionText>
            </div>
          </EditInsetGrid>

          <EditInsetGrid>
            <EditColumn>
              <EditButton onClick={ () => select(2) }>bearbeiten</EditButton>
            </EditColumn>
            <div>
              <SectionHeading>Golfdaten</SectionHeading>
              <SectionText>{ properties.golf_course }</SectionText>
              <SectionText>Handicap: { properties.handicap }</SectionText>
            </div>
          </EditInsetGrid>

          <PrimaryButton
            style={{marginTop: 30}}
            value={ properties.waitlist ? 'bestätigen und auf warteliste schreiben' : 'bestätigen und senden'}
            onClick={ apply }
          />

          <DataPolicyNotice />

        </FullWidthWrapper>
      )

      return (
        <OnboardingLayout content={ Content } sideContent={ DefaultSideContent } topContent={ Progressbar } />
      )
    }

    const ReviewDataSuccess = ({ next, Progressbar, TrackedTextField, properties, select }) => {

      const Content = () => (
        <FullWidthWrapper style={{ textAlign: 'center' }}>
          <img src={ checkmark } style={{marginBottom: 50}} />
          <Heading2>Vielen Dank für Ihre Bewerbung.</Heading2>
          <Text>Wir melden uns in Kürze bei Ihnen. Falls Sie bis dahin noch Fragen haben sind wir gerne für Sie erreichbar. Besuchen Sie uns doch auch auf unseren Social Media Kanälen.</Text>
          <GridRow
            style={{margin: '30px 0'}}
            desktop="1fr 1fr"
            phone="1fr"
            phoneRowGap
          >
            <PrimaryButton
              value="Home"
              onClick={ e => { e.preventDefault(); this.props.history.push("/")} }
            />
            <SecondaryButton
              value="Kontakt"
              onClick={ e => { e.preventDefault(); this.props.history.push("/kontakt")} }
            />
          </GridRow>
          <SocialSection />
        </FullWidthWrapper>
      )

      return (
        <OnboardingLayout content={ Content } sideContent={ DefaultSideContent } topContent={ Progressbar } />
      )
    }

    const steps = [
      {
        title: "Persönliche Daten",
        components: [
          () => <PersonalInformation />,
        ],
      },
      {
        title: "Business Daten",
        components: [
          () => <CompanyInformation />,
        ],
      },
      {
        title: "Golf Daten",
        components: [
          () => <GolfInformation />,
        ],
      },
      {
        title: "Verfügbarkeit",
        // revisitLocked: true,
        components: [
          () => <CheckLocation />,
          () => <CheckLocationSlotsAvailable />,
          () => <CheckLocationNoSlotsAvailable />,
          // () => <CheckLocationJoinedWaitlist />,
        ],
      },
      {
        title: "Bestätigung",
        components: [
          () => <ReviewData />,
          () => <ReviewDataSuccess />,
        ],
      },
    ]

    const metaData = [
      { name: 'description', content: "THE LOGE bietet die größte Netzwerkplattform für golfaffine Unternehmen in Österreich | berwerben Sie sich jetzt" },
      { property: 'og:title', content: "Mitglied werden | THE LOGE" },
      { property: 'twitter:title', content: "Mitglied werden | THE LOGE" },
      { property: 'og:description', content: "THE LOGE bietet die größte Netzwerkplattform für golfaffine Unternehmen in Österreich | berwerben Sie sich jetzt" },
      { property: 'twitter:description', content: "THE LOGE bietet die größte Netzwerkplattform für golfaffine Unternehmen in Österreich | berwerben Sie sich jetzt" },
      { property: 'og:image', content: "https://images.unsplash.com/photo-1576220258822-153014832245?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1364&q=80" },
      { property: 'twitter:image', content: "https://images.unsplash.com/photo-1576220258822-153014832245?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1364&q=80" },
    ]

    return loaded ? (<div>
      <Helmet meta={ metaData } />
      <MultistepForm steps={ steps } onRef={ref =>  { this.form = ref; this.onLoadForm() } } />
    </div>
    ) : <div></div>
  }
}


export const EditInsetGrid = styled.div `
  display: flex;
  flex-direction: row;
`

export const EditColumn = styled.div `
  padding-top: 78px;
  padding-right: 20px;
`
export const EditButton = styled.div `
  text-decoration: underline;
  color: ${ cssVar.colors.light_grey };
  cursor: pointer;
`

const DataPolicyLink = styled.span `
  color: inherit;
  text-decoration: underline;
  cursor: pointer;

  transition: all ${ cssVar.transitions.basic };

  :hover {
     color: ${ cssVar.colors.gold };
  }
`

export default withCookies(withRouter(Application))



// WEBPACK FOOTER //
// /src/pages/Application.js